/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { Fragment, useState, useEffect } from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql, Script } from "gatsby"
import Header from "./Header/Header"
import Footer from "./Footer/Footer";
import '@fontsource/poppins/100.css';
import '@fontsource/poppins/200.css';
import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import '@fontsource/poppins/800.css';
import '@fontsource/poppins/900.css';
import GDPRCheck from "./GDPRCheck/GDPRCheck";
import CountryPromptBanner from "./CountryPrompt/Banner";
import { getCountryCode } from "../functions/GeoDetect";
import { Transition } from '@headlessui/react';
import clsx from 'clsx'
import { useSession } from "@clerk/clerk-react";
import * as amplitude from '@amplitude/analytics-browser';

const Layout = ({ children, hideMenu, darkMenu }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  const [isVisible, setIsVisible] = useState(false);
  const [country, setCountry] = useState(null);

  const { isLoaded, session, isSignedIn } = useSession();

  useEffect(() => {
    const userCountry = window.sessionStorage.getItem('userCountry');
    const hideCountryPrompt = window.sessionStorage.getItem('hideCountryPrompt');
    console.log('session user country', userCountry);

    const handleCountryCode = async () => {
      const getCountry = await getCountryCode();
      window.sessionStorage.setItem('userCountry', getCountry);
      setCountry(getCountry);
      return getCountry;
    }

    if (!userCountry) {
      handleCountryCode();
    }

    if (hideCountryPrompt) {
      setIsVisible(false);
    }
  }, [])

  useEffect(() => {
    if ((country === 'US' || country === 'DE') && !window.sessionStorage.getItem('hideCountryPrompt')) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  }, [country])

  useEffect(() => {
    if (isLoaded && isSignedIn) {
      amplitude.setUserId(session?.publicUserData?.identifier);
    }
  }, [isLoaded, isSignedIn]);

  const handleCloseBanner = () => {
    setIsVisible(false);
    window.sessionStorage.setItem('hideCountryPrompt', true);
  }

  return (
    <>
      <Transition
        show={isVisible}
      >
        <div
          className={clsx([
            // Base styles
            'transition ease-in-out',
            // Shared closed styles
            'data-closed:opacity-0 data-closed:h-0',
            // Entering styles
            'data-enter:duration-100 data-enter:data-closed:-translate-y-full',
            // Leaving styles
            'data-leave:duration-300 data-leave:data-closed:translate-y-full',

          ])}
        >
          <CountryPromptBanner country={country} closeBanner={() => handleCloseBanner()} />
        </div>
      </Transition>
      <Header hideMenu={hideMenu} darkMenu={darkMenu} CountryPromptBanner={isVisible} />
      <main>{children}</main>
      <GDPRCheck />
      <Footer />
      <Script src="//rum-static.pingdom.net/pa-520e28b9abe53d7046000000.js" strategy="post-hydrate" />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
